var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "jushuitanExam" } }, [
    _c("div", { staticClass: "exam-layout" }, [
      _c(
        "aside",
        { staticClass: "chapter-nav" },
        _vm._l(_vm.chapters, function(chapter) {
          return _c(
            "div",
            {
              key: chapter.key,
              class: [
                "chapter-item",
                { active: _vm.tabCurrent === chapter.key }
              ]
            },
            [_c("p", [_vm._v(_vm._s(chapter.title))])]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("main", { staticClass: "exam-main" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.state.practiceVisible,
                expression: "state.practiceVisible"
              }
            ],
            staticClass: "content"
          },
          [
            _c(
              "div",
              { staticClass: "con-left" },
              [
                _vm.tabCurrent === "first"
                  ? _c("JstErpLoginScene", {
                      ref: "scene-first",
                      on: {
                        "step-change": _vm.onStepChange,
                        "guard-failed": _vm.onGuardFailed,
                        finish: _vm.onFinish
                      }
                    })
                  : _vm.tabCurrent === "second"
                  ? _c("JstErpSecondScene", {
                      ref: "scene-second",
                      on: {
                        "step-change": _vm.onStepChange,
                        "guard-failed": _vm.onGuardFailed,
                        finish: _vm.onFinish
                      }
                    })
                  : _vm.tabCurrent === "third"
                  ? _c("JstErpCreateAftersaleScene", {
                      ref: "scene-third",
                      on: {
                        "step-change": _vm.onStepChange,
                        "guard-failed": _vm.onGuardFailed,
                        finish: _vm.onFinish
                      }
                    })
                  : _c("JstErpOrderQueryScene", {
                      ref: "scene-four",
                      on: {
                        "step-change": _vm.onStepChange,
                        "guard-failed": _vm.onGuardFailed,
                        finish: _vm.onFinish
                      }
                    })
              ],
              1
            ),
            _vm._v(" "),
            _c("aside", { staticClass: "con-right" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", {
                class: {
                  "compact-tip":
                    _vm.tabCurrent === "third" &&
                    _vm.rightTipStep === "create-wrong-exchange"
                },
                domProps: { innerHTML: _vm._s(_vm.rightTip) }
              })
            ])
          ]
        ),
        _vm._v(" "),
        !_vm.state.practiceVisible || _vm.state.practiceCompleted
          ? _c("div", { staticClass: "stoptip" }, [
              _c("div", { staticClass: "tip" }, [
                _vm.state.practiceCompleted
                  ? _c("span", { staticClass: "el-icon-success" })
                  : _vm._e(),
                _vm._v(" "),
                _vm.state.practiceCompleted
                  ? _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.isLastChapter
                            ? "聚水潭实操完成"
                            : "实操通关，进入下一关吧"
                        )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.state.practiceVisible
                  ? _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.startStudy }
                        },
                        [_vm._v("开始实操练习")]
                      )
                    ])
                  : _vm.isLastChapter
                  ? _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "restart",
                          on: { click: _vm.restartStudy }
                        },
                        [
                          _c("i", { staticClass: "el-icon-refresh-left" }),
                          _vm._v("重练")
                        ]
                      )
                    ])
                  : _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "restart",
                          on: { click: _vm.restartStudy }
                        },
                        [
                          _c("i", { staticClass: "el-icon-refresh-left" }),
                          _vm._v("重练")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.studyNext }
                        },
                        [_vm._v("GO，下一关")]
                      )
                    ])
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [_c("span", { staticClass: "line" }), _vm._v("提示")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c242c1ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c242c1ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/simulate/juShuiTanErpExam.vue
// module id = 1386
// module chunks = 0